import { I18n } from "@/i18n/I18n";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { OrderModal } from "./OrderModal";

export function OrderItem<T extends { id: string, position: number, title: string }>(props: { listOfItems: T[], orderItems: (model: T[]) => Promise<void>, instance: string }) {
  const { listOfItems, orderItems, instance } = props;
  const [showModal, setShowModal] = useState(false);
  const reorderString = I18n.get('reorderItems', { items: I18n.get(`${(instance)}s`) });
  return (
    <>
      <Dropdown.Item
        onClick={() => {setShowModal(true);}}
        disabled={listOfItems.length === 0}
        aria-label={reorderString}
      >
        { reorderString }
      </Dropdown.Item>
      {showModal && (
        <OrderModal
          handleClose={(items) => void orderItems(items)}
          reorderItems={listOfItems}
          title={I18n.get('orderContainers', { model: I18n.get(instance)})}
          setShowOrderModal={setShowModal}
        />
      )}
    </>
  );
}
